import { Component, ChangeDetectionStrategy} from '@angular/core';
import {IFloatingFilterAngularComp} from "ag-grid-angular";
import {IFloatingFilterParams} from "ag-grid-community";

@Component({ standalone: false,
    styleUrls: ['irb-input-floating-filter.component.scss'],
    selector: 'irb-input-floating-filter-component',
    template: `
        <div class="ag-floating-filter-input" role="presentation">
            <div role="presentation" ref="eFloatingFilterText" class="ag-labeled ag-label-align-left ag-text-field ag-input-field ag-disabled" disabled="">
                <div ref="eWrapper" class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper" role="presentation">
                    <input [(ngModel)]="currentValue" class="ag-input-field-input ag-text-field-input" type="text" (click)="params.showParentFilter()" style="cursor: default;" readonly/>
                </div>
            </div>
        </div>`,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class IrbInputFloatingFilterComponent implements IFloatingFilterAngularComp {
    params: IFloatingFilterParams;
    currentValue: string = null;

    agInit(params: IFloatingFilterParams): void {
        this.params = params;
    }

    onParentModelChanged(parentModel: any) {
        if (!parentModel) {
            this.currentValue = null;
        } else {
            this.params.parentFilterInstance((f: any) => {
                this.currentValue = f.getModelAsString();
            });
        }
    }

    onInputBoxChanged() {
    }
}
